import { HttpHeaders, HttpParams } from '@angular/common/http';

export class HttpRequestOptions {
    public headers?: HttpHeaders | Record<string, string | string[]>;
    public observe?: 'body';
    public params?: HttpParams | Record<string, string | string[]>;
    public reportProgress?: boolean;
    public responseType?: 'json';
    public withCredentials?: boolean;
}
